import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import Integrations from "@/pages/Integrations";

export const Route = createFileRoute("/integrazioni")({
  head: () => buildRouteHead({ pathname: "/integrazioni" }),
  component: Integrations,
});
